import React, { memo } from 'react';
import clsx from 'clsx';

import { useLink, trackingId, useResponsiveCtx } from '@blueprint/ui';

import { PillLabel } from './Pill';

/**
 * LabelPill
 */
const LabelPill = ({
  children,
  mode = 'light',
  size = 'large',
  className,
  ...rest
}) => {
  const { hMedia } = useResponsiveCtx();
  const linkProps = useLink(rest);
  const { disabled } = linkProps;
  const pillState = clsx(
    {
      disabled,
    },
    className,
  );

  return (
    <PillLabel
      role="button"
      {...linkProps}
      mode={mode}
      pillSize={size}
      className={pillState}
      data-trackid={trackingId('LabelPill')}
      data-testid="LabelPill"
      hMedia={hMedia}
    >
      {children}
    </PillLabel>
  );
};

LabelPill.displayName = 'LabelPill';

export default memo(LabelPill);
